// extracted by mini-css-extract-plugin
export default {"section":"section-WKan","active":"active-OrZZ","isDragging":"isDragging-SP_b","isDropping":"isDropping-ER1i","actions":"actions-R6iW","title":"title-l8d8"};